// const newLocation = `https://api.${process.env.VUE_APP_ENV}.fygr.io`;
import type {RouteRecordRaw, RouteComponent} from 'vue-router';

const lazy = (fn: () => Promise<any>) => fn as () => Promise<RouteComponent>;
const routes = [
  {
    path: '/oauth2/authorize',
    name: 'oauth-authorize',
    meta: {layout: 'no-auth'},
    component: lazy(() => import('@/components/pages/auth/OauthAuthorize.vue')),
  },
  {
    path: '/passwordrecovery',
    name: 'oauth-password-recovery',
    meta: {layout: 'no-auth'},
    component: lazy(() => import('@/components/pages/PasswordRecovery.vue')),
  },
  {
    path: '/fygrclosewindow',
    name: 'oauth-password-recovery-close',
    meta: {layout: 'no-auth'},
    component: lazy(() => import('@/components/pages/PasswordRecovery.vue')),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'oauth-error',
    meta: {layout: 'no-auth'},
    component: lazy(() => import('@/components/pages/auth/OauthNotFound.vue')),
  },
  // {
  //   path: '/oauth2/pkce/getOauthRedirectUrl',
  //   name: 'oauth-api',
  //   beforeEnter(to, from, next) { // eslint-disable-line no-unused-vars
  //     window.location.replace(newLocation + to.fullPath);
  //   },
  // },
] satisfies RouteRecordRaw[];

export default routes;
